import React, { useState, useEffect } from 'react';
import { complianceService } from '../../services/api';

export default function SystemBanner() {
    const [announcement, setAnnouncement] = useState<any>(null);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const fetchAnnouncement = async () => {
            try {
                const res = await complianceService.getActiveAnnouncement();
                if (res.data?.success && res.data?.data) {
                    setAnnouncement(res.data.data);
                }
            } catch (error) {
                console.error('Failed to fetch announcement', error);
            }
        };

        fetchAnnouncement();
        // Check every 5 minutes
        const interval = setInterval(fetchAnnouncement, 5 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    if (!announcement || !isVisible) return null;

    const getColors = () => {
        switch (announcement.type) {
            case 'critical': return 'bg-red-600 text-white border-red-700';
            case 'warning': return 'bg-amber-500 text-white border-amber-600';
            case 'maintenance': return 'bg-blue-600 text-white border-blue-700';
            case 'info':
            default: return 'bg-indigo-600 text-white border-indigo-700';
        }
    };

    const getIcon = () => {
        switch (announcement.type) {
            case 'critical': return 'fa-exclamation-triangle';
            case 'warning': return 'fa-exclamation-circle';
            case 'maintenance': return 'fa-tools';
            case 'info':
            default: return 'fa-info-circle';
        }
    };

    return (
        <div className={`${getColors()} border-b px-4 py-3 sm:px-6 lg:px-8 shadow-md relative z-50 animate-fadeIn`}>
            <div className="flex items-center justify-between flex-wrap">
                <div className="w-0 flex-1 flex items-center">
                    <span className="flex p-2 rounded-lg bg-white/20">
                        <i className={`fas ${getIcon()} text-white`} aria-hidden="true" />
                    </span>
                    <p className="ml-3 font-medium text-white truncate text-sm sm:text-base">
                        <span className="md:hidden font-bold mr-2 uppercase tracking-wider">{announcement.title}: </span>
                        <span className="hidden md:inline font-bold mr-2 uppercase tracking-wider">{announcement.title}: </span>
                        <span className="opacity-90">{announcement.message}</span>
                    </p>
                </div>
                <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
                    <button
                        type="button"
                        onClick={() => setIsVisible(false)}
                        className="-mr-1 flex p-2 rounded-md hover:bg-white/20 focus:outline-none sm:-mr-2 transition-colors"
                    >
                        <span className="sr-only">Dismiss</span>
                        <i className="fas fa-times text-white" aria-hidden="true" />
                    </button>
                </div>
            </div>
        </div>
    );
}
